// extracted by mini-css-extract-plugin
module.exports = {"circle":"Progress_circle__2hu3k","container":"Progress_container__3LDSC","percentage":"Progress_percentage__2u83e","svg":"Progress_svg__3PRoq"};